import store from '../../../store/store';
import { ActionStatus } from '../../../common/constants/action-status';
import { BusinessUnit, ClientTokenRequest } from '../../checkout/shop-checkout.interface';
import { StoreState } from '../../../store/store.interface';
import { getBraintreeClientToken, getBraintreeClientTokenApiStatus } from '../../checkout/shop-checkout';
import { getCart } from '../../cart/shop-cart/store/shop-cart.selectors';
import { isApplePayEnabled } from '../apple-pay/store/apple-pay.selectors';
import { isGooglePayEnabled } from '../google-pay/store/google-pay.selectors';
import { isPaypalEnabled } from '../paypal/store/paypal-selectors';
import { isSuccessUser } from '../../user-profile/user-profile.selectors';

export const ERROR_ADDRESS_VALIDATION_MESSAGE = `The address tied to this payment method is not valid. 
Please update it or change to a different payment method.`;

/**
 * Checks if third party payment methods are enabled.
 *
 * @param state
 */
export function are3rdPartyPaymentsEnabled(state: StoreState): boolean {
  return isApplePayEnabled(state)
    || isGooglePayEnabled(state)
    || isPaypalEnabled(state);
}

/**
 * Dispatches the braintree client token request.
 *
 * @param countryCode
 * @param currencyCode
 */
export function dispatchBraintreeClientToken(countryCode: string, currencyCode: string) {
  const cart = getCart(store.getState() as StoreState);
  const clientTokenRequest: ClientTokenRequest = {
    type: 'cart',
    countryCode: countryCode,
    currencyCode: currencyCode,
    businessUnit: cart?.orderBusinessUnit as BusinessUnit
  };
  store.dispatch(getBraintreeClientToken(clientTokenRequest));
}

/**
 * Checks if braintree dependencies are loaded.
 */
export function isLoadingBraintreeDependencies(): boolean {
  const state = store.getState() as StoreState;
  if (!isSuccessUser(state)) {
    return false;
  }
  const braintreeStatus = getBraintreeClientTokenApiStatus(state);
  return isLoadingBraintree(braintreeStatus);
}

/**
 * Checks if braintree is loading.
 *
 * @param braintreeStatus
 */
function isLoadingBraintree(braintreeStatus: ActionStatus): boolean {
  return braintreeStatus === ActionStatus.loading;
}
